module.exports = "/_next/static/images/halfPhoneHalfWinit-52cf4967b6c10cb8b1589f7957ab0009.webp";